import {
  Entity,
  Expand,
  GetManyParamsHelper,
  getManyUsingOData,
  GetOneParamsHelper,
  getOneUsingOData,
  GetPaginatedParamsHelper,
  getPaginatedUsingOData,
  ODataClient,
  Relations,
  SelectConfig,
} from "@ccq/ts-lib";
import type { EmptyObject } from "type-fest";

export class ODataHelper {
  static $inject = ["$q"];
  constructor(protected $q: ng.IQService) {}

  /** Important: This must be used with .then(), not async await. */
  getOne<E extends Entity, R extends Relations<E> | EmptyObject, S extends SelectConfig<Expand<E, R>>>(
    client: ODataClient<E>,
    params: GetOneParamsHelper<E, R, S>,
  ) {
    return this.$q.when(getOneUsingOData(client, params));
  }

  /** Important: This must be used with .then(), not async await. */
  getMany<E, R extends Relations<E> | EmptyObject, S extends SelectConfig<Expand<E, R>>>(
    client: ODataClient<E>,
    params?: GetManyParamsHelper<E, R, S>,
  ) {
    return this.$q.when(getManyUsingOData(client, params));
  }

  /** Important: This must be used with .then(), not async await. */
  getPaginated<E, R extends Relations<E> | EmptyObject, S extends SelectConfig<Expand<E, R>>>(
    client: ODataClient<E>,
    params?: GetPaginatedParamsHelper<E, R, S>,
  ) {
    return this.$q.when(getPaginatedUsingOData(client, params));
  }
}
